import {Component, OnDestroy, OnInit} from '@angular/core';
import {CellEditorComponentBase} from "@shared/components/cell-components/cell-component";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {Configuration} from "@shared/models/configuration";
import {DialogService} from "@shared/services/dialog-service";
import {
  AddAssociateEnterpriseEntityCommand,
  DeleteAssociateEnterpriseEntityCommand,
  UpdateAssociateEnterpriseEntityCommand
} from "../../commands/dac6-reporter.command";
import {CommandService} from "@core/services/command.service";
import {EntityFields} from "../../Fields";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {DialogModel} from "@shared/models/dialog.model";
import {skip,takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {SnackBarService} from "@core/services/snack-bar.service";
import {QueryProvider} from "@shared/queries/query-provider";
import {ParticleState} from "@shared/store/reducers/particle.reduer";
import {select, Store} from "@ngrx/store";
import {getQueryResponse} from "@shared/store/selectors/query.selector";

@Component({
    standalone: false,
    selector: 'particle-rtp-associate-enterprise-cell-editor',
  templateUrl: './rtp-associate-enterprise-cell-editor.component.html',
  styleUrls: ['./rtp-associate-enterprise-cell-editor.component.scss']
})
export class RtpAssociateEnterpriseCellEditorComponent extends CellEditorComponentBase implements OnInit, OnDestroy {

  sourceType: string;
  invalidateSubject: InvalidateSubject;
  private unSubscribe$ = new Subject<void>();
  private displayTextConfig: string;
  userApp: string;
  constructor(private dialogService: DialogService,
              private snackberService: SnackBarService,
              protected particleStore: Store<ParticleState>,
              private fuseSplashScreenService: FuseSplashScreenService,
              private commandService: CommandService) {
    super();
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
    this.sourceType = this.fieldDefinition.configKey;
    this.userApp = this.sourceType.split('-')[0];
    const config = Configuration.getSmartGridConfig(this.sourceType);
    if (config.DisplayTextConfig) {
      this.displayTextConfig = config.DisplayTextConfig;
    }
    if(this.item.cells[this.fieldDefinition.key] && this.item.cells[this.fieldDefinition.key].value) {
      config.Parameters['KEY'] = this.item.cells[this.fieldDefinition.key].value;
    }
    if(this.userApp === 'DataSurvey' &&
      this.item.cells['SurveyId'] && this.item.cells['SurveyId'].value){
      config.Parameters['SURVEY_ID']=this.item.cells['SurveyId'].value;
      if(this.item.cells['SourceItemId']){
        config.Parameters['ID'] = this.item.cells['SourceItemId'].value;
      }else{
        config.Parameters['ID'] = this.item.cells['ItemId'].value;
      }
    }else{
      config.Parameters['ID'] = this.item.id;
    }

  }
  Add(){
    const dialogModel: DialogModel = DialogModel.create(
      'Select an Entity',
      'AddAssociateEnterpriseEntityDialogComponent',
      {
        rtpId: this.item.id
      },
      '600px',
      '700px'
    );
    dialogModel.okCaption = 'Done';
    dialogModel.cancelCaption = 'Cancel';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe((res: any) => {
      if(res && res.action === 'OK'){
        console.log('boo');
        const command = new AddAssociateEnterpriseEntityCommand(this.item.id, dialogModel.input['selectedRTPEntity'].id, 'Dac6Api');
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(commandState=>{
          if(commandState && commandState.Payload && commandState.Payload['Message']){
            this.snackberService.showError(commandState.Payload['Message']);
          }
          else{
            this.invalidateSubject.invalidate();
          }
          this.fuseSplashScreenService.hide();

        })
      }
    });
  }
  onGridCellValueChange(event) {

    if (event.action) {
      switch (event.action.id) {
        case 'Delete':
          this.deleteRecord(event);
          break;
        case 'Edit':
          this.editRecord(event);
          break;
      }
    }
    console.log(event);
  }

  private editRecord(event: any) {
    this.openEditor(event);
  }
  public openEditor(event: any) {
    let minWidth = '600px';
    const maxWidth = '600px';
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.sourceType).subscribe(state => {
      console.log('After Edit', state);
      if (state.action === 'OK') {
        const fieldValues = {};
        if(event.fieldDefinition.key === EntityFields.Country){
          fieldValues[EntityFields.CountryCode] = event.item.cells[event.fieldDefinition.key].value;
        }else{
          fieldValues[event.fieldDefinition.key] = event.item.cells[event.fieldDefinition.key].value;
        }

        const command = new UpdateAssociateEnterpriseEntityCommand(event.item.id, 'Dac6Api', fieldValues);
        this.commandService.executeCommand(command).subscribe(commandState=>{
          console.log(commandState);
          this.invalidateSubject.invalidate();
        })
      }
    });
  }

  //#region "Not being used now"
  /*async onClicked() {
    let promise;
    if (this.displayTextConfig) {
      promise = new Promise((resolve, reject) => {
        this.fuseSplashScreenService.show();
        QueryProvider.invokeQueryByExecutionId(this.particleStore, this.displayTextConfig, this.item.id, {'[ID]': this.item.id});
        this.particleStore.pipe(select(getQueryResponse, this.item.id),skip(1), takeUntil(this.unSubscribe$)).subscribe(res => {
          if (typeof res === 'string') {
            resolve(res);
          }
        });
      });
      await promise.then(res => {
        this.fuseSplashScreenService.hide();
        this.item.cells[this.fieldDefinition.key].displayText = res;
        return true;
      });
    } else {
      return true;
    }
  }*/
  //#endregion

  private deleteRecord(event: any){
    const command = new DeleteAssociateEnterpriseEntityCommand(this.item.id, event.item.id, 'Dac6Api');
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(command).subscribe(commandState=>{
      this.fuseSplashScreenService.hide();
      this.invalidateSubject.invalidate();
    })
  }
  ngOnDestroy(){
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
